import { Controller } from "@hotwired/stimulus"
import { addInputEventForRequiredFields, formHasChanges } from "../helpers";

export default class extends Controller {
  static targets = ["submitButton", "imageContainer", "withImages", "withoutImages"]

  connect() {
    addInputEventForRequiredFields();
  }

  handleSubmit(e) {
    if (this.imageContainerTarget.querySelectorAll('.file-wrapper').length === 0) {
      // Use consistent class toggling
      this.withImagesTarget.classList.add('d-none');
      this.withoutImagesTarget.classList.remove('d-none');
      // Don't disable button yet since we're showing confirmation
    } else {
      this.submitButtonTarget.disabled = true;
      e.target.closest('form').requestSubmit();
    }
  }
  
  handleNo(e) {
    // Re-enable the button and restore original display
    this.submitButtonTarget.disabled = false;
    this.withImagesTarget.classList.remove('d-none');
    this.withoutImagesTarget.classList.add('d-none');
  }

  handleFileChange(e) {
    this.withImagesTarget.style.display = 'block';
    this.withoutImagesTarget.classList.add('d-none');
  }

  handleBackClick(event) {
    event.preventDefault()

    const isShowModal = localStorage.getItem('isShowModal') === 'true'
    const confirmDiscardModal = document.querySelector('#confirmDiscardModal')

    if (isShowModal && confirmDiscardModal) {
      // Show the confirmation modal without pre-setting redirectToPath.
      // Set navigationType to 'back' so the confirm handler uses history.back().
      localStorage.removeItem('redirectToPath')
      confirmDiscardModal.dataset.navigationType = 'back'
      confirmDiscardModal.click()
      return
    }

    // No unsaved changes — just go back. In the native shell this screen is
    // a sheet with its own web view and no history: visit, and the shell
    // dismisses the sheet.
    const fallbackUrl = event.currentTarget.dataset.fallbackUrl
    if (document.body.classList.contains('native-app') && fallbackUrl) {
      Turbo.visit(fallbackUrl)
    } else if (window.history.length > 1) {
      window.history.back()
    } else if (fallbackUrl) {
      Turbo.visit(fallbackUrl)
    }
  }

}
